import type { goodVibeCardEn, goodVibeDetailDialogEn, goodVibesEn } from "./en.ts";

export const goodVibesFr: typeof goodVibesEn = {
    GoodVibeDetailRoute: {
        deleteSuccess: "Bonne Vibe supprimée",
        deleteCommentSuccess: "Réponse supprimée",
        deleteError: "Une erreur est survenue lors de la suppression de la Bonne Vibe. Veuillez réessayer.",
        deleteErrorForbidden: "Vous n'avez plus la permission de supprimer cette Bonne Vibe.",
        editSuccess: "Bonne Vibe mise à jour",
        editError: "Une erreur est survenue lors de la mise à jour de la Bonne Vibe. Veuillez réessayer.",
        editErrorForbidden: "Vous n'avez plus la permission de modifier cette Bonne Vibe.",
        editCommentSuccess: "Réponse mise à jour",
        addCommentError: "Une erreur est survenue lors de la publication de votre réponse. Veuillez réessayer."
    }
};

export const goodVibeCardFr: typeof goodVibeCardEn = {
    eyebrow: "Bonnes Vibes",
    unknownSender: "Membre supprimé",
    from: "De {{name}}",
    fromUnknownSender: "D'un membre supprimé",
    peopleCount_one: "{{count}} personne",
    peopleCount_other: "{{count}} personnes",
    reactionCount_one: "{{count}}",
    reactionCount_other: "{{count}}",
    reactionMembersOverflow_one: "et {{count}} autre",
    reactionMembersOverflow_other: "et {{count}} autres",
    replyCount_one: "{{count}} réponse",
    replyCount_other: "{{count}} réponses",
    addReply: "Ajouter une réponse",
    openDetailAriaLabel: "Ouvrir la Bonne Vibe de {{sender}}",
    openDetailUnreadAriaLabel: "Ouvrir la Bonne Vibe non lue de {{sender}}",
    react: {
        button: "Réagir",
        addReactionLabel: "Ajouter la réaction {{glyph}}",
        removeReactionLabel: "Retirer la réaction {{glyph}}"
    }
};

export const goodVibeDetailDialogFr: typeof goodVibeDetailDialogEn = {
    heading: "Bonnes Vibes de {{sender}}",
    unknownSender: "Membre supprimé",
    toLabel: "à",
    reactionCount_one: "{{count}}",
    reactionCount_other: "{{count}}",
    reactionMembersOverflow_one: "et {{count}} autre",
    reactionMembersOverflow_other: "et {{count}} autres",
    repliesLabel: "Réponses",
    repliesSubtitle: {
        public: "Toute votre organisation peut voir les réponses",
        direct: "Les destinataires, leurs gestionnaires et leurs supérieurs hiérarchiques peuvent voir les réponses"
    },
    visibility: {
        public: "Publique",
        direct: "Directe",
        publicTooltip: "Toute votre organisation peut voir cela.",
        directTooltip: "Les destinataires, leurs gestionnaires et leurs supérieurs hiérarchiques peuvent voir cela."
    },
    react: {
        button: "+ Réagir",
        addReactionLabel: "Ajouter la réaction {{glyph}}",
        removeReactionLabel: "Retirer la réaction {{glyph}}"
    },
    delete: {
        button: "Supprimer",
        confirmTitle: "Supprimer cette Bonne Vibe ?",
        confirmDescription: "Cela supprime ce que vous avez écrit. Les destinataires verront uniquement qu'il a été supprimé, et cette action est irréversible.",
        confirmAction: "Supprimer",
        cancelAction: "Conserver"
    },
    edit: {
        button: "Modifier",
        dialogTitle: "Modifier la Bonne Vibe",
        messageLabel: "Message",
        messageCharactersLeft: "{{remaining}} caractères restants",
        subjectLabel: "Sujet",
        audienceLabel: "Audience",
        publicLabel: "Public",
        publicDescription: "Tous les membres de l'entreprise peuvent voir ceci.",
        directLabel: "Direct",
        directDescription: "Seulement les destinataires, leurs gestionnaires et leurs supérieurs peuvent voir ceci.",
        saveAction: "Enregistrer et envoyer",
        cancelAction: "Annuler",
        fromLabel: "De {{sender}}",
        recipientsLabel: "À",
        removeRecipient: "Supprimer {{name}}",
        recipientSearchPlaceholder: "Ajouter",
        recipientSearchNoResults: "Aucun résultat trouvé",
        recipientSearchLoading: "Recherche en cours…",
        recipientSearchError: "Impossible de charger les résultats",
        recipientSearchLoadedMore: "{{count}} résultats supplémentaires chargés",
        discardChangesTitle: "Abandonner vos modifications?",
        discardChangesBody: "Vos modifications n'ont pas été enregistrées. Quitter maintenant fera perdre ce que vous avez modifié.",
        discardChangesConfirmLabel: "Abandonner",
        discardChangesCancelLabel: "Continuer l'édition"
    },
    deleteComment: {
        button: "Supprimer",
        confirmQuestion: "Supprimer cette réponse?",
        confirmAction: "Supprimer",
        cancelAction: "Annuler"
    },
    editComment: {
        button: "Modifier",
        label: "Modifier votre réponse",
        saveAction: "Enregistrer",
        cancelAction: "Annuler"
    },
    reactToComment: {
        button: "+ Réagir",
        addReactionLabel: "Ajouter la réaction {{glyph}} à la réponse",
        removeReactionLabel: "Retirer la réaction {{glyph}} de la réponse"
    },
    reply: {
        label: "Ajouter une réponse",
        placeholder: "Répondez pour garder la bonne énergie",
        submitButton: "Envoyer",
        justNow: "À l'instant"
    },
    discardReply: {
        title: "Abandonner votre réponse?",
        confirmLabel: "Abandonner",
        cancelLabel: "Continuer l'édition"
    }
};
